import '../../style/default.less';
import './index.less'; // style dependencies
// deps-lint-skip: date-picker

import '../../select/style';
import '../../radio/style';
import '../../date-picker/style';